// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"6a369975","505":"20fbb3c5","774":"282ee8fe","787":"30f2ab1b","858":"4a17b139","908":"e0fd77aa","994":"3187f449","995":"31a60ab5"}[chunkId] + ".chunk.js";
};